export default "__VITE_ASSET__c98677d5__"